import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { Container, Row, Col, Button, Form, Stack } from "react-bootstrap";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { FcPlus, FcList } from "react-icons/fc";
import { TiEdit } from "react-icons/ti";

import UserDataService from "../../services/user.service";
import ProjectDataService from "../../services/project.service";
import FormInputText from "../../components/FormField/FormInput";
import FormSelect from "../../components/FormField/FormSelect";
import { useAuthContext } from "../../contexts/AuthContext";

import "./User.scss";

const ROLE_LIST = [
  { id: 1, name: "superadmin", label: "Super Admin", accessTo: ["superadmin"] },
  { id: 2, name: "admin", label: "Admin", accessTo: ["superadmin"] },
  { id: 3, name: "user", label: "User", accessTo: ["superadmin", "admin"] },
];

function UserCreate() {
  let { user, setIsLoading } = useAuthContext();
  let { userId } = useParams();

  const navigate = useNavigate();
  const location = useLocation();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [roleList, set_roleList] = useState(
    ROLE_LIST.filter((rl) => rl.accessTo.includes(user?.role))
  );
  const [role, setRole] = useState("");
  const [userObj, set_userObj] = useState({});
  const [projectList, setProjectList] = useState([]);

  const locationPathName = location && location.pathname;
  let isEdit = false,
    isView = false,
    isCreate = false;
  if (userId) {
    if (locationPathName.includes("/edit")) isEdit = true;
    else if (locationPathName.includes("/detail")) isView = true;
  } else {
    isCreate = true;
  }

  useEffect(() => {
    fetchAllProjects();
    if (isEdit || isView) fetchUserDetails(userId);
  }, []);

  useEffect(() => {
    if (userObj.id) {
      setName(userObj.name);
      setEmail(userObj.email);
      setRole(userObj?.role);
      fetchAllProjects();
    }
  }, [userObj]);

  function fetchUserDetails(userId) {
    setIsLoading(true);
    UserDataService.get(userId).then((response) => {
      setIsLoading(false);
      set_userObj(response.data.data);
    });
  }

  function fetchAllProjects() {
    setIsLoading(true);
    ProjectDataService.getAll().then((response) => {
      setIsLoading(false);
      formatProjectsList(response.data.data);
    });
  }

  function formatProjectsList(inputList) {
    const userProjts = userObj.projects || [];
    setProjectList(
      inputList.map((itm) => ({
        projectId: itm.id,
        projectName: itm.projectName,
        selected: userProjts.some((prl) => prl.projectId === itm.id)
          ? true
          : false,
      }))
    );
  }

  const createEditUser = () => {
    var data = {
      email,
      password,
      name,
      role,
      projects:
        role === "superadmin"
          ? projectList
          : projectList.filter((pr) => pr.selected),
    };

    if (isEdit) {
      setIsLoading(true);
      UserDataService.update(userId, data)
        .then((response) => {
          console.log("response ---- ", response);
          setIsLoading(false);
          if (response.data.success) {
            toast.success("User Updated!");
            navigate("/users");
          } else {
            toast.error("Error in updating User");
          }
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("Error Catch in update user => ", err);
          toast.error(err.response.data.msg || "Error Catch in update user");
        });
    } else if (isCreate) {
      UserDataService.create(data)
        .then((response) => {
          setIsLoading(false);
          if (response.data.success) {
            toast.success("User Created!");
            navigate("/users");
          } else {
            toast.error("Error in creating User");
          }
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("Error Catch in create user => ", err);
          toast.error(err.response.data.msg || "Error Catch in create user");
        });
    }
  };

  const onChangeProject = (e, projId) => {
    const projlist = projectList.map((prj) => {
      if (prj.projectId === projId) prj.selected = e;
      return prj;
    });
    setProjectList(projlist);
  };

  return (
    <Container fluid="md">
      <Row>
        <Col sm={8}>
          <h1 className="mt-4 mb-2 pageTitle">
            {isEdit ? "Edit" : isView ? "View" : "Create New"} user
          </h1>
        </Col>
        <Col sm={4}>
          <Stack direction="horizontal" gap={1}>
            <Button
              className="btn btn-light mt-4"
              theme="accent"
              onClick={() => navigate(`/users`)}
            >
              <FcList /> View All
            </Button>
          </Stack>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col>
          <Form>
            <Row>
              <Col md="12" className="form-group">
                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">Name</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {isView ? (
                      name
                    ) : (
                      <FormInputText
                        className="forminput"
                        placeholder="User Name"
                        value={name}
                        setFunc={setName}
                        showLabel={false}
                      />
                    )}
                  </Col>
                </Row>
                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">Email Id</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {isView ? (
                      email
                    ) : (
                      <FormInputText
                        className="forminput"
                        placeholder="Email ID"
                        value={email}
                        setFunc={setEmail}
                        showLabel={false}
                        type="email"
                      />
                    )}
                  </Col>
                </Row>

                {!isView && (
                  <Row className="form-group-row">
                    <Col className="form-label" md="4">
                      <label htmlFor="feFirstName">Password</label>
                    </Col>
                    <Col className="form-field" md="8">
                      {isView ? (
                        password
                      ) : (
                        <FormInputText
                          className="forminput"
                          placeholder="Password"
                          value={password}
                          setFunc={setPassword}
                          showLabel={false}
                          type="password"
                        />
                      )}
                    </Col>
                  </Row>
                )}

                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="projectStructureSelected">Role</label>
                  </Col>
                  {isView ? (
                    <Col className="form-field" md="8">
                      {role}
                    </Col>
                  ) : (
                    <Col className="form-field" md="8">
                      <FormSelect
                        className="forminput"
                        placeholder="Select Role"
                        optionList={roleList}
                        value={role}
                        setFunc={setRole}
                        showLabel={false}
                      />
                    </Col>
                  )}
                </Row>

                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="Role">Projects</label>
                  </Col>
                  <Col className="" md="8">
                    <Row>
                      <Col className="form-field" md="9">
                        {projectList.length ? (
                          projectList.map((proj, inx) => (
                            <Row key={proj.projectId} className="mb-2">
                              <Col md="3">
                                <BootstrapSwitchButton
                                  checked={proj.selected}
                                  id={proj.projectId}
                                  onlabel="Yes"
                                  offlabel="No"
                                  onChange={(e) =>
                                    onChangeProject(e, proj.projectId)
                                  }
                                />
                              </Col>
                              <Col md="9">
                                <div className="text-01">
                                  {proj.projectName}
                                </div>
                              </Col>
                            </Row>
                          ))
                        ) : (
                          <></>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>

                {(isEdit || isCreate) && (
                  <Row className="form-group-row">
                    <Col className="form-button" md="12">
                      <Button
                        className="btn btn-primary"
                        theme="accent"
                        onClick={() => createEditUser()}
                      >
                        <FcPlus /> {isEdit ? "Update" : "Create"} User
                      </Button>
                    </Col>
                  </Row>
                )}

                {isView && (
                  <Row className="form-group-row">
                    <Col className="form-button" md="12">
                      <Button
                        className="btn btn-primary"
                        theme="accent"
                        onClick={() => navigate(`/users/${userId}/edit`)}
                      >
                        <TiEdit /> Edit user
                      </Button>
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default UserCreate;
